import { CreateCodeArguments } from '@dtx-company/app/shared/code/src/components/Homepage/CreateFlowcodeForm/CreateFlowcodeFormDesktop/CreateFlowcodeFormDesktop.hooks'
import { useAuthCache } from '@dtx-company/app/shared/authentication/AuthCache/hooks'
import { useCallback } from 'react'

export function useGetCachedLOCGFormValues(): () => Promise<CreateCodeArguments | undefined> {
  const authCache = useAuthCache()

  return useCallback(async () => {
    if (!authCache) return

    const formValues = authCache.locgFormValues.get()

    return formValues
  }, [authCache])
}
